module.exports = __webpack_public_path__ + "static/img/poster_bg.33e38d7b.png";